import { makeStyles, Text, tokens } from '@fluentui/react-components';
import { ReactNode } from 'react';

const useStyles = makeStyles({
    bar: {
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: tokens.colorNeutralBackground1,
        borderTop: `1px solid ${tokens.colorNeutralStroke2}`,
        boxShadow: '0 -2px 12px rgba(20, 30, 50, 0.06)',
        zIndex: 60,
    },
    inner: {
        maxWidth: '1080px',
        margin: '0 auto',
        padding: '14px 28px',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
    },
    label: {
        fontSize: tokens.fontSizeBase200,
        color: tokens.colorNeutralForeground2,
    },
    spacer: {
        flex: 1,
    },
});

interface StickyActionBarProps {
    /** Context label on the left (e.g. "4 sections" or "Step 2 of 4"). */
    label?: string;
    /** Right-aligned action buttons. */
    children: ReactNode;
}

/** Fixed bottom action bar for the form (surface bg, top border, upward shadow). */
const StickyActionBar = ({ label, children }: StickyActionBarProps) => {
    const styles = useStyles();
    return (
        <div className={styles.bar}>
            <div className={styles.inner}>
                {label && <Text className={styles.label}>{label}</Text>}
                <span className={styles.spacer} />
                {children}
            </div>
        </div>
    );
};

export default StickyActionBar;
